import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { t } from 'i18next';

import { Alert, Box, Tooltip } from '@mui/material';

import { classNames } from '../../../../utils/styles';

import { useAppContext } from '../../../../contexts/app';

import { DEFAULT_STATUS_INFO, DEFAULT_STATUS_INFO_LIST } from './util';
import { statusStyles } from './styles';
import { SkeletonStatusCell } from './Loader';

const StatusCell = ({
  className,
  row,
  displayText = true,
  statusInfoList = DEFAULT_STATUS_INFO_LIST,
  property = 'status',
  noBG = false,
}) => {
  const { isLoading } = useAppContext();

  if ((isLoading.page || isLoading.showSkeleton) && isLoading.table) {
    return <SkeletonStatusCell />;
  }

  const statusInfo = statusInfoList[row?.[property]] || DEFAULT_STATUS_INFO;

  const alertClasses = classNames({
    [className]: !!className,
    'dn-flex-middle': true,
    [`dn-status-${statusInfo.status?.toLowerCase()}`]: statusInfo?.status,
    'dn-status-inactive': !statusInfo?.status,
    'dn-no-title': !displayText || !statusInfo?.status,
    'dn-status-no-bg': noBG,
  });

  const text = statusInfo?.text || statusInfo?.status || '';

  return (
    <Tooltip
      title={t(statusInfo?.title) || ''}
    >
      <Alert
        severity={statusInfo?.severity}
        icon={statusInfo?.icon}
        className={alertClasses}
        sx={statusStyles}
      >
        {
          displayText && text && (
            <Box component="span">
              {t(text)}
            </Box>
          )
        }
      </Alert>
    </Tooltip>
  );
};

StatusCell.propTypes = {
  className: PropTypes.string,
  row: PropTypes.object,
  displayText: PropTypes.bool,
  statusInfoList: PropTypes.object,
  property: PropTypes.string,
  noBG: PropTypes.bool,
};

export default memo(StatusCell);
